import { forwardRef, type Ref, type SVGProps } from "react";
const IconYouTubeSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M31.334 8.165a4.01 4.01 0 0 0-2.83-2.83C26.007 4.668 16 4.668 16 4.668s-10.007 0-12.502.669A4.01 4.01 0 0 0 .67 8.165C0 10.659 0 15.867 0 15.867s0 5.208.67 7.703a4.01 4.01 0 0 0 2.828 2.829c2.495.669 12.502.669 12.502.669s10.007 0 12.502-.67a4.01 4.01 0 0 0 2.829-2.828C32 21.075 32 15.867 32 15.867s0-5.208-.67-7.702zM12.799 20.667v-9.6l8.314 4.8z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconYouTubeSVG);
ForwardRef.displayName = "IconYouTube";
export { ForwardRef as IconYouTube };
